import { healthFetch, type HealthResult } from "./apiClient";
import type { HealthInfoBody, HealthLiveBody, HealthReadyBody } from "../types/api";

/** GET /health/live — process is running. Not overall system health. */
export function getLiveness(): Promise<HealthResult<HealthLiveBody>> {
  return healthFetch<HealthLiveBody>("/health/live");
}

/** GET /health/ready — authoritative "is the system usable" signal. May be 503 when degraded. */
export function getReadiness(): Promise<HealthResult<HealthReadyBody>> {
  return healthFetch<HealthReadyBody>("/health/ready");
}

/** GET /health — version, uptime, per-entity last successful sync map. */
export function getHealthInfo(): Promise<HealthResult<HealthInfoBody>> {
  return healthFetch<HealthInfoBody>("/health");
}
